import React, { useEffect, useState } from "react";
import "../Landingpage/Landingpage.css";
import Header from "../Dashboard/Header/Header";
import ThaliSchedule from "../../img/landing/ThaliSchedule";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Landingpage() {


  localStorage.removeItem('procurmentMiqaatdata');
  localStorage.removeItem('endMiqaatDate');
  localStorage.removeItem('activeTab');
  localStorage.removeItem('endDate');
  localStorage.removeItem('startDate');
  localStorage.removeItem('selectedCheckbox');
  localStorage.removeItem('activeMiqaatTab');


  localStorage.removeItem('procurmentdata');
  localStorage.removeItem('selectedMiqaatCheckbox');
  localStorage.removeItem('startMiqaatDate');
  localStorage.removeItem('Enddate');

  localStorage.removeItem('currentStartWeekFMB');
  localStorage.removeItem('currentEndWeekFMB');
  localStorage.removeItem('currentStartWeekMiqaat');
  localStorage.removeItem('currentEndWeekMiqaat');
  localStorage.removeItem('totalselectedFullThaaliCount');

  //Removed Combined
  localStorage.removeItem('currentStartWeekFMBCombined');
  localStorage.removeItem('currentEndWeekMiqaatCombined');
  localStorage.removeItem('totalselectedFullThaaliCountCombined');
  localStorage.removeItem('totalselectedMiqaatThaalCountCombined');  
  localStorage.removeItem('procurmentdataCombined');
  localStorage.removeItem('activeTabCombined');
  localStorage.removeItem('selectedCheckboxCombined');
  localStorage.removeItem('selectedFMBCheckboxCombined');
  localStorage.removeItem('selectedMiqaatCheckboxCombined');
  localStorage.removeItem('selectedTotalFullCountCombined');
  localStorage.removeItem('selectedTotalMiqaatThaalCountCombined');
  localStorage.removeItem('currentPageCombined');



  const history = useNavigate();
  const location = useLocation();
  const user_category = localStorage.getItem("author_type");
  const user_Role = localStorage.getItem("access_Role");
  console.log("user_Role", user_Role);
  const user_last = localStorage.getItem("author_last");

  const { pathname } = useLocation();

  let myDate = new Date();
  let hours = myDate.getHours();
  let greet;

  if (hours < 12) greet = "Morning";
  else if (hours >= 12 && hours <= 17) greet = "Afternoon";
  else if (hours >= 17 && hours <= 24) greet = "Evening";

  return (
    <>
      <Header />
      <section className="Landingpage">
        <div className="container">
          <div className="Heding_text">
            {/* <h5>Good {greet}</h5> */}
            {/* <h1>{user_category} &nbsp; {user_last}</h1> */}
          </div>

          <div className="row mb-4">
            {/* <h1>Thaali Registration</h1> */}
            {user_Role.includes("GEN") || 
            user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ||
            user_Role.includes("INV") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Thaali-reg"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/Thaali-reg"
                  >
                    {/* <div className='Landing_div2 '> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 30 30"
                      fill="none"
                    >
                      <path
                        d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                        fill="#AE8340"
                      />
                      <path
                            d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                            fill="#AE8340"
                      />
                      <path
                            d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                            fill="#AE8340"
                      />
                      <path
                            d="M19.5998 10.8148V16.122H0.399902V10.8148H19.5998ZM0.399902 17.3709H19.5998V22.6782L0.399902 22.6784V17.3709ZM3.4768 1.44887C3.4768 0.762038 4.03054 0.200195 4.70745 0.200195H15.292C15.9689 0.200195 16.5227 0.762038 16.5227 1.44887V6.44413H14.6764L14.6768 3.32194C14.6768 2.97851 14.4 2.6976 14.0615 2.6976H5.93837C5.5999 2.6976 5.32304 2.97853 5.32304 3.32194V6.4439H3.47679L3.4768 1.44887ZM13.446 6.4439H6.55354V3.94627H13.4458L13.446 6.4439ZM2.86142 7.6928H17.1383C18.2767 7.6928 19.2305 8.50445 19.5075 9.56609L0.492264 9.56587C0.76935 8.50446 1.72303 7.6928 2.86142 7.6928ZM18.369 25.8002H1.63066C0.953745 25.8002 0.400013 25.2384 0.400013 24.5515V23.9272H19.5999V24.5515C19.5999 25.2381 19.0459 25.8002 18.369 25.8002Z"
                            fill="#AE8340"
                      />
                    </svg>
                    <h1>Thaali Registration</h1>
                    {/* </div> */}
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            { user_Role.includes("QRM") ||
              user_Role.includes("ADM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/User-Registration"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/User-Registration"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="26"
                      height="26"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"
                        fill="#AE8340"
                      />
                      <path
                        d="M17.5 17.5h5v1.5h-5zm0-3h5v1.5h-5zm0-3h5v1.5h-5z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>User Registration</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <div className="row g-4">
          {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ||
            user_Role.includes("INV") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Menu-Planning"
                        ? "active Landing_div"
                        : " Landing_div"
                    }
                    to="/Menu-Planning"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                    >
                      <path
                        d="M1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V1.5C0 1.1 0.15 0.75 0.45 0.45C0.75 0.15 1.1 0 1.5 0H16.5C16.9 0 17.25 0.15 17.55 0.45C17.85 0.75 18 1.1 18 1.5V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V1.5H1.5V18.5Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M4 5.5C4 5.08579 4.33579 4.75 4.75 4.75H13.25C13.6642 4.75 14 5.08579 14 5.5C14 5.91421 13.6642 6.25 13.25 6.25H4.75C4.33579 6.25 4 5.91421 4 5.5Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M4 9.75C4 9.33579 4.33579 9 4.75 9H13.25C13.6642 9 14 9.33579 14 9.75C14 10.1642 13.6642 10.5 13.25 10.5H4.75C4.33579 10.5 4 10.1642 4 9.75Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M4 14C4 13.5858 4.33579 13.25 4.75 13.25H10.25C10.6642 13.25 11 13.5858 11 14C11 14.4142 10.6642 14.75 10.25 14.75H4.75C4.33579 14.75 4 14.4142 4 14Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Menu Planning</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {user_Role.includes("ADM") ||
            user_Role.includes("OPT") ||
            user_Role.includes("ODM") ||
            user_Role.includes("PRM") ||
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ||
            user_Role.includes("INV") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Calendar"
                        ? "active Landing_div"
                        : " Landing_div"
                    }
                    to="/Calendar"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="20"
                      viewBox="0 0 18 20"
                      fill="none"
                    >
                      <path
                        d="M4.75 11.5C4.53333 11.5 4.35417 11.4292 4.2125 11.2875C4.07083 11.1458 4 10.9667 4 10.75C4 10.5333 4.07083 10.3542 4.2125 10.2125C4.35417 10.0708 4.53333 10 4.75 10H13.25C13.4667 10 13.6458 10.0708 13.7875 10.2125C13.9292 10.3542 14 10.5333 14 10.75C14 10.9667 13.9292 11.1458 13.7875 11.2875C13.6458 11.4292 13.4667 11.5 13.25 11.5H4.75ZM4.75 16C4.53333 16 4.35417 15.9292 4.2125 15.7875C4.07083 15.6458 4 15.4667 4 15.25C4 15.0333 4.07083 14.8542 4.2125 14.7125C4.35417 14.5708 4.53333 14.5 4.75 14.5H10.225C10.4417 14.5 10.6208 14.5708 10.7625 14.7125C10.9042 14.8542 10.975 15.0333 10.975 15.25C10.975 15.4667 10.9042 15.6458 10.7625 15.7875C10.6208 15.9292 10.4417 16 10.225 16H4.75ZM1.5 20C1.1 20 0.75 19.85 0.45 19.55C0.15 19.25 0 18.9 0 18.5V3C0 2.6 0.15 2.25 0.45 1.95C0.75 1.65 1.1 1.5 1.5 1.5H3.125V0.8C3.125 0.583333 3.20417 0.395833 3.3625 0.2375C3.52083 0.0791666 3.71667 0 3.95 0C4.16667 0 4.35417 0.0791666 4.5125 0.2375C4.67083 0.395833 4.75 0.583333 4.75 0.8V1.5H13.25V0.8C13.25 0.583333 13.3292 0.395833 13.4875 0.2375C13.6458 0.0791666 13.8417 0 14.075 0C14.2917 0 14.4792 0.0791666 14.6375 0.2375C14.7958 0.395833 14.875 0.583333 14.875 0.8V1.5H16.5C16.9 1.5 17.25 1.65 17.55 1.95C17.85 2.25 18 2.6 18 3V18.5C18 18.9 17.85 19.25 17.55 19.55C17.25 19.85 16.9 20 16.5 20H1.5ZM1.5 18.5H16.5V7.75H1.5V18.5Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Calendar Setup</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {user_Role.includes("ADM") ||
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ||
            user_Role.includes("INV") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Dashboard"
                        ? "Landing_div active"
                        : "Landing_div"
                    }
                    to="/Dashboard"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M1.5 18C1.1 18 0.75 17.85 0.45 17.55C0.15 17.25 0 16.9 0 16.5V1.5C0 1.1 0.15 0.75 0.45 0.45C0.75 0.15 1.1 0 1.5 0H16.5C16.9 0 17.25 0.15 17.55 0.45C17.85 0.75 18 1.1 18 1.5V16.5C18 16.9 17.85 17.25 17.55 17.55C17.25 17.85 16.9 18 16.5 18H1.5ZM4.5 13.85C4.7 13.85 4.875 13.775 5.025 13.625C5.175 13.475 5.25 13.3 5.25 13.1C5.25 12.9 5.175 12.725 5.025 12.575C4.875 12.425 4.7 12.35 4.5 12.35C4.3 12.35 4.125 12.425 3.975 12.575C3.825 12.725 3.75 12.9 3.75 13.1C3.75 13.3 3.825 13.475 3.975 13.625C4.125 13.775 4.3 13.85 4.5 13.85ZM4.5 9.75C4.7 9.75 4.875 9.675 5.025 9.525C5.175 9.375 5.25 9.2 5.25 9C5.25 8.8 5.175 8.625 5.025 8.475C4.875 8.325 4.7 8.25 4.5 8.25C4.3 8.25 4.125 8.325 3.975 8.475C3.825 8.625 3.75 8.8 3.75 9C3.75 9.2 3.825 9.375 3.975 9.525C4.125 9.675 4.3 9.75 4.5 9.75ZM4.5 5.65C4.7 5.65 4.875 5.575 5.025 5.425C5.175 5.275 5.25 5.1 5.25 4.9C5.25 4.7 5.175 4.525 5.025 4.375C4.875 4.225 4.7 4.15 4.5 4.15C4.3 4.15 4.125 4.225 3.975 4.375C3.825 4.525 3.75 4.7 3.75 4.9C3.75 5.1 3.825 5.275 3.975 5.425C4.125 5.575 4.3 5.65 4.5 5.65ZM8.55 13.85H13.15C13.3667 13.85 13.5458 13.7792 13.6875 13.6375C13.8292 13.4958 13.9 13.3167 13.9 13.1C13.9 12.8833 13.8292 12.7042 13.6875 12.5625C13.5458 12.4208 13.3667 12.35 13.15 12.35H8.55C8.33333 12.35 8.15417 12.4208 8.0125 12.5625C7.87083 12.7042 7.8 12.8833 7.8 13.1C7.8 13.3167 7.87083 13.4958 8.0125 13.6375C8.15417 13.7792 8.33333 13.85 8.55 13.85ZM8.55 9.75H13.15C13.3667 9.75 13.5458 9.67917 13.6875 9.5375C13.8292 9.39583 13.9 9.21667 13.9 9C13.9 8.78333 13.8292 8.60417 13.6875 8.4625C13.5458 8.32083 13.3667 8.25 13.15 8.25H8.55C8.33333 8.25 8.15417 8.32083 8.0125 8.4625C7.87083 8.60417 7.8 8.78333 7.8 9C7.8 9.21667 7.87083 9.39583 8.0125 9.5375C8.15417 9.67917 8.33333 9.75 8.55 9.75ZM8.55 5.65H13.15C13.3667 5.65 13.5458 5.57917 13.6875 5.4375C13.8292 5.29583 13.9 5.11667 13.9 4.9C13.9 4.68333 13.8292 4.50417 13.6875 4.3625C13.5458 4.22083 13.3667 4.15 13.15 4.15H8.55C8.33333 4.15 8.15417 4.22083 8.0125 4.3625C7.87083 4.50417 7.8 4.68333 7.8 4.9C7.8 5.11667 7.87083 5.29583 8.0125 5.4375C8.15417 5.57917 8.33333 5.65 8.55 5.65Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Thaali Schedule</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Registeruser"
                        ? "Landing_div active"
                        : "Landing_div"
                    }
                    to="/Registeruser"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M36.6667 14.9993V13.3327C36.6667 12.416 35.9167 11.666 35 11.666C34.0833 11.666 33.3333 12.416 33.3333 13.3327V14.9993H31.6667C30.75 14.9993 30 15.7493 30 16.666C30 17.5827 30.75 18.3327 31.6667 18.3327H33.3333V19.9993C33.3333 20.916 34.0833 21.666 35 21.666C35.9167 21.666 36.6667 20.916 36.6667 19.9993V18.3327H38.3333C39.25 18.3327 40 17.5827 40 16.666C40 15.7493 39.25 14.9993 38.3333 14.9993H36.6667Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M13.3334 19.9993C17.0167 19.9993 20.0001 17.016 20.0001 13.3327C20.0001 9.64935 17.0167 6.66602 13.3334 6.66602C9.65008 6.66602 6.66675 9.64935 6.66675 13.3327C6.66675 17.016 9.65008 19.9993 13.3334 19.9993Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M13.3333 21.666C8.88333 21.666 0 23.8993 0 28.3327V33.3327H26.6667V28.3327C26.6667 23.8993 17.7833 21.666 13.3333 21.666Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M20.8501 6.74805C22.3834 8.51471 23.3334 10.8147 23.3334 13.3314C23.3334 15.848 22.3834 18.148 20.8501 19.9147C24.1168 19.498 26.6668 16.7314 26.6668 13.3314C26.6668 9.93138 24.1168 7.16471 20.8501 6.74805Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M27.55 23.0488C29.0334 24.4322 30 26.1655 30 28.3322V33.3322H33.3334V28.3322C33.3334 25.9155 30.6834 24.1488 27.55 23.0488Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Registration Report</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {/* {user_Role.includes("PRO") || user_Role.includes("ADM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Procurement"
                        ? "Landing_div active"
                        : "Landing_div"
                    }
                    to="/Procurement"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M33.3335 3.33203H6.66683C5.00016 3.33203 3.3335 4.83203 3.3335 6.66536V11.682C3.3335 12.882 4.05016 13.9154 5.00016 14.4987V33.332C5.00016 35.1654 6.8335 36.6654 8.3335 36.6654H31.6668C33.1668 36.6654 35.0002 35.1654 35.0002 33.332V14.4987C35.9502 13.9154 36.6668 12.882 36.6668 11.682V6.66536C36.6668 4.83203 35.0002 3.33203 33.3335 3.33203ZM23.3335 23.332H16.6668C15.7502 23.332 15.0002 22.582 15.0002 21.6654C15.0002 20.7487 15.7502 19.9987 16.6668 19.9987H23.3335C24.2502 19.9987 25.0002 20.7487 25.0002 21.6654C25.0002 22.582 24.2502 23.332 23.3335 23.332ZM33.3335 11.6654H6.66683V6.66536H33.3335V11.6654Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Procurement (FMB)</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )} */}

            {/* {user_Role.includes("PRO") || user_Role.includes("ADM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Procurement-Miqaat"
                        ? "Landing_div active"
                        : "Landing_div"
                    }
                    to="/Procurement-Miqaat"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="512"
                      viewBox="0 0 24 24"
                      width="512"
                    >
                      <path
                        d="m19 1h-14a1 1 0 0 0 -.65.25 4 4 0 0 1 2.65 3.35 1.75 1.75 0 0 1 0 .4v17a1 1 0 0 0 .58.91 1 1 0 0 0 1.07-.15l2.85-2.44 2.85 2.44a1 1 0 0 0 1.3 0l2.85-2.44 2.85 2.44a1 1 0 0 0 .65.24 1.06 1.06 0 0 0 .42-.09 1 1 0 0 0 .58-.91v-17a4 4 0 0 0 -4-4zm-1 14h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm0-4h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm0-4h-6a1 1 0 0 1 0-2h6a1 1 0 0 1 0 2zm-13-2v8h-3a1 1 0 0 1 -1-1v-7c0-.14 0-.27 0-.4a2 2 0 0 1 4 .4z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Procurement (Miqaat)</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )} */}

          {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ||
            user_Role.includes("INV") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Procurement-Combined"
                        ? "Landing_div active"
                        : "Landing_div"
                    }
                    to="/Procurement-Combined"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="40"
                      height="40"
                      viewBox="0 0 40 40"
                      fill="none"
                    >
                      <path
                        d="M33.3335 3.33203H6.66683C5.00016 3.33203 3.3335 4.83203 3.3335 6.66536V11.682C3.3335 12.882 4.05016 13.9154 5.00016 14.4987V33.332C5.00016 35.1654 6.8335 36.6654 8.3335 36.6654H31.6668C33.1668 36.6654 35.0002 35.1654 35.0002 33.332V14.4987C35.9502 13.9154 36.6668 12.882 36.6668 11.682V6.66536C36.6668 4.83203 35.0002 3.33203 33.3335 3.33203ZM23.3335 23.332H16.6668C15.7502 23.332 15.0002 22.582 15.0002 21.6654C15.0002 20.7487 15.7502 19.9987 16.6668 19.9987H23.3335C24.2502 19.9987 25.0002 20.7487 25.0002 21.6654C25.0002 22.582 24.2502 23.332 23.3335 23.332ZM33.3335 11.6654H6.66683V6.66536H33.3335V11.6654Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Procurement (Combined)</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

          {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ||
            user_Role.includes("INV") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/ViewInventory"
                        ? "Landing_div active"
                        : "Landing_div"
                    }
                    to="/ViewInventory"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="35"
                      viewBox="0 0 32 35"
                      fill="none"
                    >
                      <path
                        d="M3.33333 7.33464H6.66667V9.0013C6.66667 10.8346 8.16667 12.3346 10 12.3346H20C21.8333 12.3346 23.3333 10.8346 23.3333 9.0013V7.33464H26.6667V15.668H30V7.33464C30 5.5013 28.5 4.0013 26.6667 4.0013H19.7C19 2.06797 17.1667 0.667969 15 0.667969C12.8333 0.667969 11 2.06797 10.3 4.0013H3.33333C1.5 4.0013 0 5.5013 0 7.33464V30.668C0 32.5013 1.5 34.0013 3.33333 34.0013H13.3333V30.668H3.33333V7.33464ZM15 4.0013C15.9167 4.0013 16.6667 4.7513 16.6667 5.66797C16.6667 6.58464 15.9167 7.33464 15 7.33464C14.0833 7.33464 13.3333 6.58464 13.3333 5.66797C13.3333 4.7513 14.0833 4.0013 15 4.0013Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M31.2502 19.4207C30.5669 18.7374 29.4335 18.7374 28.7502 19.4207L20.8502 27.3374L17.0835 23.5874C16.4002 22.904 15.2835 22.904 14.5835 23.5874C13.9002 24.2707 13.9002 25.404 14.5835 26.0874L19.6669 31.154C20.3169 31.804 21.3669 31.804 22.0169 31.154L31.2335 21.9207C31.9335 21.2374 31.9335 20.104 31.2502 19.4207Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Inventory</h1>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

          {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Dishes"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/Dishes"
                  >
                    {/* <div className='Landing_div2'> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="13"
                      viewBox="0 0 20 13"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M10.8914 1.89148V1.89121C10.8914 1.39421 10.4884 0.991211 9.99136 0.991211C9.49435 0.991211 9.09136 1.39421 9.09136 1.89121V1.89148H9.09096C4.6177 1.89148 0.991299 5.51788 0.991299 9.99079H18.9913C18.9913 5.51754 15.3649 1.89148 10.8916 1.89148H10.8914ZM0.991357 11.7911H18.9914C19.3227 11.7911 19.5914 12.0598 19.5914 12.3911C19.5914 12.7225 19.3227 12.9911 18.9914 12.9911H0.991357C0.660017 12.9911 0.391357 12.7225 0.391357 12.3911C0.391357 12.0598 0.660017 11.7911 0.991357 11.7911ZM0.991357 9.99114H18.9914C18.9914 10.6538 18.454 11.1911 17.7914 11.1911H2.19136C1.52868 11.1911 0.991357 10.6538 0.991357 9.99114Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Dishes</h1>
                    {/* </div> */}
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Ingredients"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/Ingredients"
                  >
                    {/* <div className='Landing_div2'> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M7.675 14C8.19167 14 8.625 13.8208 8.975 13.4625C9.325 13.1042 9.5 12.675 9.5 12.175C9.5 11.675 9.325 11.2458 8.975 10.8875C8.625 10.5292 8.2 10.35 7.7 10.35C7.18333 10.35 6.74583 10.5292 6.3875 10.8875C6.02917 11.2458 5.85 11.675 5.85 12.175C5.85 12.675 6.02917 13.1042 6.3875 13.4625C6.74583 13.8208 7.175 14 7.675 14ZM12.325 14C12.825 14 13.2542 13.8208 13.6125 13.4625C13.9708 13.1042 14.15 12.675 14.15 12.175C14.15 11.675 13.9708 11.2458 13.6125 10.8875C13.2542 10.5292 12.825 10.35 12.325 10.35C11.825 10.35 11.3958 10.5292 11.0375 10.8875C10.6792 11.2458 10.5 11.675 10.5 12.175C10.5 12.675 10.6792 13.1042 11.0375 13.4625C11.3958 13.8208 11.825 14 12.325 14ZM10 9.325C10.5 9.325 10.9292 9.15 11.2875 8.8C11.6458 8.45 11.825 8.01667 11.825 7.5C11.825 7 11.6458 6.57083 11.2875 6.2125C10.9292 5.85417 10.5 5.675 10 5.675C9.5 5.675 9.07083 5.85417 8.7125 6.2125C8.35417 6.57083 8.175 7 8.175 7.5C8.175 8.01667 8.35417 8.45 8.7125 8.8C9.07083 9.15 9.5 9.325 10 9.325ZM10 20C8.63333 20 7.34167 19.7375 6.125 19.2125C4.90833 18.6875 3.84583 17.9708 2.9375 17.0625C2.02917 16.1542 1.3125 15.0917 0.7875 13.875C0.2625 12.6583 0 11.3583 0 9.975C0 8.60833 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.02917 3.825 2.9375 2.925C3.84583 2.025 4.90833 1.3125 6.125 0.7875C7.34167 0.2625 8.64167 0 10.025 0C11.3917 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3667 19.7375 12.6583 19.2125 13.875C18.6875 15.0917 17.975 16.1542 17.075 17.0625C16.175 17.9708 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Ingredients</h1>
                    {/* </div> */}
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Vendors"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/Vendors"
                  >
                    {/* <div className='Landing_div2 '> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="17"
                      viewBox="0 0 20 17"
                      fill="none"
                    >
                      <path
                        d="M4.02389 0L0.666748 5.37143C0.666748 6.60758 1.71881 7.60952 3.01679 7.60952C4.3146 7.60952 5.36667 6.60758 5.36667 5.37143C5.36667 6.60758 6.41889 7.60952 7.71671 7.60952C9.01468 7.60952 10.0667 6.60758 10.0667 5.37143C10.0667 6.60758 11.1188 7.60952 12.4168 7.60952C13.7146 7.60952 14.7668 6.60758 14.7668 5.37143C14.7668 6.60758 15.8189 7.60952 17.1167 7.60952C18.4147 7.60952 19.4667 6.60758 19.4667 5.37143L16.1096 0H4.02389ZM5.36667 7.51161C4.76966 8.12201 3.93509 8.50484 3.01679 8.50484C2.97932 8.50484 2.94201 8.49907 2.90485 8.49782V16.0618C2.90485 16.3379 3.12871 16.5618 3.40485 16.5618H10.6858C10.9619 16.5618 11.1858 16.3379 11.1858 16.0618V9.84747H14.7668V16.0618C14.7668 16.3379 14.9907 16.5618 15.2668 16.5618H16.7287C17.0048 16.5618 17.2287 16.3379 17.2287 16.0618V8.49782C17.1915 8.49907 17.1542 8.50484 17.1167 8.50484C16.1984 8.50484 15.3639 8.12204 14.7668 7.51161C14.1697 8.12201 13.3351 8.50484 12.4168 8.50484C11.4984 8.50484 10.6638 8.12204 10.0668 7.51161C9.46975 8.12201 8.63518 8.50484 7.71672 8.50484C6.79842 8.50484 5.96384 8.12204 5.36667 7.51161ZM5.36667 9.84758H8.9477V13.8762H5.36667V9.84758Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Vendors</h1>
                    {/* </div> */}
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ||
            user_Role.includes("MIQ") ||
            user_Role.includes("MDM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Caterer"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/Caterer"
                  >
                    {/* <div className='Landing_div2 '> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 30 30"
                      fill="none"
                    >
                      <path
                        d="M27.9231 13.9429H2.07689C0.929791 13.9429 0 14.6769 0 15.5826C0 16.4882 0.929791 17.2222 2.07689 17.2222H27.9231C29.0702 17.2222 30 16.4882 30 15.5826C30.0001 14.677 29.0702 13.9429 27.9231 13.9429Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M16.3304 2.95775C16.8053 2.65137 17.1147 2.19164 17.1147 1.66998C17.1147 0.747656 16.1675 0 14.9994 0C13.8314 0 12.8842 0.747656 12.8842 1.66998C12.8842 2.19164 13.1937 2.65143 13.6685 2.95775C7.28449 3.48299 2.30713 7.74422 2.30713 12.9231H27.6918C27.6918 7.74422 22.7144 3.48299 16.3304 2.95775ZM9.66196 11.2834H5.53787C5.53787 8.01428 8.65506 5.32412 12.6697 4.95404L9.66196 11.2834Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M23.1175 22.3144L22.4811 21.9592C21.8458 21.6056 21.4327 21.0526 21.3461 20.4419L21.0549 18.3851C21.064 18.151 21.0669 17.8229 20.8587 17.6557C20.6504 17.4885 20.3646 17.3952 20.0674 17.398V17.4009C19.7125 17.404 19.2667 17.377 18.886 17.7763L17.7984 19.316C17.0777 20.2643 16.1517 20.2629 15.1846 19.9996L7.60264 17.372C7.18702 17.2592 6.72687 17.3742 6.46882 17.6549L6.45851 17.6663C6.14635 18.0058 6.22636 18.479 6.64034 18.7424L15.3693 24.4789L20.2828 26.4282L19.4706 27.6071L24.8913 29.9988L29.252 23.6709L23.831 21.2793L23.1175 22.3144ZM27.3815 24.0978L24.3444 28.5053L21.3412 27.1802L24.3781 22.7727L27.3815 24.0978Z"
                        fill="#AE8340"
                      />
                      <path
                        d="M25.3545 25.2857C25.7686 25.2857 26.1044 25.0207 26.1044 24.6937C26.1044 24.3667 25.7686 24.1016 25.3545 24.1016C24.9403 24.1016 24.6045 24.3667 24.6045 24.6937C24.6045 25.0207 24.9403 25.2857 25.3545 25.2857Z"
                        fill="#AE8340"
                      />
                    </svg>
                    <h1>Caterer</h1>
                    {/* </div> */}
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {user_Role.includes("ADM") || 
            user_Role.includes("OPT") || 
            user_Role.includes("ODM") || 
            user_Role.includes("PRM") || 
            user_Role.includes("PRO") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Feedback"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/Feedback"
                  >
                    <div className="Landing_div2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="19"
                        viewBox="0 0 20 19"
                        fill="none"
                      >
                        <path
                          d="M8.125 12H15.25C15.4667 12 15.6458 11.9292 15.7875 11.7875C15.9292 11.6458 16 11.4667 16 11.25C16 11.0333 15.9292 10.8542 15.7875 10.7125C15.6458 10.5708 15.4667 10.5 15.25 10.5H9.625L8.125 12ZM4.375 12H5.675C5.775 12 5.86667 11.9792 5.95 11.9375C6.03333 11.8958 6.11667 11.8417 6.2 11.775L12.275 5.775C12.375 5.675 12.425 5.55 12.425 5.4C12.425 5.25 12.375 5.125 12.275 5.025L10.9 3.775C10.8167 3.69167 10.7125 3.65 10.5875 3.65C10.4625 3.65 10.3583 3.69167 10.275 3.775L4.225 9.925C4.15833 10.0083 4.10417 10.0917 4.0625 10.175C4.02083 10.2583 4 10.35 4 10.45V11.625C4 11.725 4.0375 11.8125 4.1125 11.8875C4.1875 11.9625 4.275 12 4.375 12ZM0 18.2V1.5C0 1.11667 0.15 0.770833 0.45 0.4625C0.75 0.154167 1.1 0 1.5 0H18.5C18.8833 0 19.2292 0.154167 19.5375 0.4625C19.8458 0.770833 20 1.11667 20 1.5V14.5C20 14.8833 19.8458 15.2292 19.5375 15.5375C19.2292 15.8458 18.8833 16 18.5 16H4L1.275 18.725C1.04167 18.9583 0.770833 19.0125 0.4625 18.8875C0.154167 18.7625 0 18.5333 0 18.2Z"
                          fill="#AE8340"
                        />
                      </svg>
                      <h1>Feedback</h1>
                    </div>
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            { user_Role.includes("ADM") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Users"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/Users"
                  >
                    {/* <div className='Landing_div2'> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="16"
                      viewBox="0 0 24 16"
                      fill="none"
                    >
                      <path
                        d="M1.69995 16.0001C1.48328 16.0001 1.30412 15.9293 1.16245 15.7876C1.02078 15.6459 0.949951 15.4668 0.949951 15.2501V13.6501C0.949951 13.0668 1.09995 12.5376 1.39995 12.0626C1.69995 11.5876 2.11662 11.2334 2.64995 11.0001C3.86662 10.4668 4.96245 10.0834 5.93745 9.8501C6.91245 9.61676 7.91662 9.5001 8.94995 9.5001C9.98328 9.5001 10.9833 9.61676 11.95 9.8501C12.9166 10.0834 14.0083 10.4668 15.225 11.0001C15.7583 11.2334 16.1791 11.5876 16.4875 12.0626C16.7958 12.5376 16.95 13.0668 16.95 13.6501V15.2501C16.95 15.4668 16.8791 15.6459 16.7375 15.7876C16.5958 15.9293 16.4166 16.0001 16.2 16.0001H1.69995ZM17.9 16.0001C18.0666 15.9668 18.1999 15.8793 18.2999 15.7376C18.4 15.5959 18.45 15.4168 18.45 15.2001V13.6501C18.45 12.6001 18.1833 11.7376 17.65 11.0626C17.1166 10.3876 16.4166 9.84176 15.55 9.4251C16.7 9.55843 17.7833 9.75426 18.7999 10.0126C19.8166 10.2709 20.6416 10.5668 21.275 10.9001C21.8249 11.2168 22.2583 11.6084 22.575 12.0751C22.8916 12.5418 23.0499 13.0668 23.0499 13.6501V15.2501C23.0499 15.4668 22.9791 15.6459 22.8375 15.7876C22.6958 15.9293 22.5166 16.0001 22.2999 16.0001H17.9ZM8.94995 7.9751C7.84995 7.9751 6.94995 7.6251 6.24995 6.9251C5.54995 6.2251 5.19995 5.3251 5.19995 4.2251C5.19995 3.1251 5.54995 2.2251 6.24995 1.5251C6.94995 0.825098 7.84995 0.475098 8.94995 0.475098C10.05 0.475098 10.95 0.825098 11.65 1.5251C12.35 2.2251 12.7 3.1251 12.7 4.2251C12.7 5.3251 12.35 6.2251 11.65 6.9251C10.95 7.6251 10.05 7.9751 8.94995 7.9751ZM17.95 4.2251C17.95 5.3251 17.6 6.2251 16.9 6.9251C16.2 7.6251 15.3 7.9751 14.2 7.9751C14.0166 7.9751 13.8125 7.9626 13.5875 7.9376C13.3625 7.9126 13.1583 7.86676 12.975 7.8001C13.375 7.38343 13.6791 6.87093 13.8875 6.2626C14.0958 5.65426 14.2 4.9751 14.2 4.2251C14.2 3.4751 14.0958 2.8126 13.8875 2.2376C13.6791 1.6626 13.375 1.13343 12.975 0.650098C13.1583 0.600098 13.3625 0.558431 13.5875 0.525098C13.8125 0.491765 14.0166 0.475098 14.2 0.475098C15.3 0.475098 16.2 0.825098 16.9 1.5251C17.6 2.2251 17.95 3.1251 17.95 4.2251Z"
                        fill="#AE8340"
                      />
                    </svg>

                    <h1>Users</h1>
                    {/* </div> */}
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}

            {user_Role.includes("ADM") ||
             user_Role.includes("OPT") ? (
              <>
                <div className="col-lg-2 col-md-4">
                  <Link
                    className={
                      pathname === "/Report"
                        ? "active Landing_div"
                        : "Landing_div"
                    }
                    to="/Report"
                  >
                    {/* <div className='Landing_div2'> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="30"
                      height="30"
                      viewBox="0 0 30 30"
                      fill="none"
                    >
                      <path
                        d="M20.5333 0H9.46667C9.03333 0 8.6 0.183333 8.3 0.483333L0.483333 8.3C0.183333 8.6 0 9.03333 0 9.46667V20.5167C0 20.9667 0.183333 21.3833 0.483333 21.7L8.28333 29.5C8.6 29.8167 9.03333 30 9.46667 30H20.5167C20.9667 30 21.3833 29.8167 21.7 29.5167L29.5 21.7167C29.8167 21.4 29.9833 20.9833 29.9833 20.5333V9.46667C29.9833 9.01667 29.8 8.6 29.5 8.28333L21.7 0.483333C21.4 0.183333 20.9667 0 20.5333 0ZM15 23.8333C13.8 23.8333 12.8333 22.8667 12.8333 21.6667C12.8333 20.4667 13.8 19.5 15 19.5C16.2 19.5 17.1667 20.4667 17.1667 21.6667C17.1667 22.8667 16.2 23.8333 15 23.8333ZM15 16.6667C14.0833 16.6667 13.3333 15.9167 13.3333 15V8.33333C13.3333 7.41667 14.0833 6.66667 15 6.66667C15.9167 6.66667 16.6667 7.41667 16.6667 8.33333V15C16.6667 15.9167 15.9167 16.6667 15 16.6667Z"
                        fill="#AE8340"
                      />
                    </svg>

                    <h1>Report</h1>
                    {/* </div> */}
                  </Link>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
        </div>

        <h5 class="version">v9.12</h5>
      </section>
    </>
  );
}
